import { css } from 'styled-components';

export const typography = {
  /* Headline */
  headlineMedium: css`
    font-size: 24px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0;
  `,
  headlineLarge: css`
    font-size: 28px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0;
  `,
  /* Title */
  titleExtraSmall: css`
    font-size: 14px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0;
  `,
  titleSmall: css`
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0;
  `,
  titleMedium: css`
    font-size: 18px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0;
  `,
  titleLarge: css`
    font-size: 20px;
    font-weight: 600;
    line-height: 1.4;
    letter-spacing: 0;
  `,
  /* Body */
  bodyExtraLarge: css`
    font-size: 18px;
    font-weight: 400;
    line-height: 1.8;
    letter-spacing: 0;
  `,
  bodyLarge: css`
    font-size: 17px;
    font-weight: 400;
    line-height: 1.8;
    letter-spacing: 0;
  `,
  bodyMedium: css`
    font-size: 16px;
    font-weight: 300;
    line-height: 1.8;
    letter-spacing: 0;
  `,
  bodySmall: css`
    font-size: 15px;
    font-weight: 300;
    line-height: 1.6;
    letter-spacing: 0;
  `,
  bodyXSmall: css`
    font-size: 14px;
    font-weight: 300;
    line-height: 1.6;
    letter-spacing: 0;
  `,
  bodyExtraSmall: css`
    font-size: 13px;
    font-weight: 300;
    line-height: 1.6;
    letter-spacing: 0;
  `,
  /* Label */
  labelLarge: css`
    font-size: 14px;
    font-weight: 500;
    line-height: 1.6;
    letter-spacing: 0;
  `,
  labelMedium: css`
    font-size: 12px;
    font-weight: 400;
    line-height: 1.6;
    letter-spacing: 0;
  `,
  labelSmall: css`
    font-size: 11px;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0;
  `,
  labelExtraSmall: css`
    font-size: 10px;
    font-weight: 600;
    line-height: 1;
    letter-spacing: 0;
  `,
};
